export function email (val) {
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return pattern.test(val)
}

export function min (val, min) {
  if (!!val && !isNaN(min)) {
    if (val.length >= parseInt(min)) {
      return true
    }
    return false
  } else {
    return false
  }
}

export function incluye (val, caracter) {
  if (!!val && !!caracter) {
    return val.includes(caracter)
  } else {
    return false
  }
}

export function largo (val, num1, num2) {
  if (!!val && !!num1 && !!num2) {
    if (String(val).length <= num1 && String(val).length >= num2) {
      return true
    }
    return false
  } else if (!!val && !!num1 && !num2) {
    if (String(val).length >= num1) {
      return true
    }
  }
  return false
}
